import { Component, OnInit, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
//import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as commonActions from '../../../store/actions/common.actions';
import * as fromRootStore from '../../../reducers';

import { PhClientModel } from '../../../model/index';
import { PhClientService, CommonService, PromoTypeService, PromoReferenceService } from '../../../services/index';
import { AddEditReferenceComponent } from '../reference/addEditReference.component';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/distinctUntilChanged';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/observable/of';

@Component({
    selector: 'add-edit-phClient-window',
    templateUrl: './addEditphClient.component.html'
})
export class AddEditphClientComponent implements OnInit {

    showReference: boolean;
    public list: any[] = [];

    @Output() clientUpdateEvent = new EventEmitter();
    title: string;
    mode: string;
    @Input() clientdata: PhClientModel[] = [];
    @Input() clientPhoto = [];

    clientCtrl: FormControl;
    ClientSexCtrl: FormControl;
    SalutationCtrl: FormControl;
    MarStatusCtrl: FormControl;
    cityCtrl: FormControl;
    areaCtrl: FormControl;
    stateCtrl: FormControl;
    districtCtrl: FormControl;
    branchControl: FormControl;
    clientSexList: any[];
    salutationList: any[];
    assignToCtrl: FormControl;
    assignToList: any[];
    marStatusList: any[];
    filteredItems: Observable<any[]>;

    // Reference Client ID and Employee fields
    refClientCtrl: FormControl;
    refEmployeeCtrl: FormControl;
    filteredRefClientList: Observable<any[]>;
    filteredRefEmployeeList: Observable<any[]>;
    @ViewChild('clientAutoComp') clientAutoComp;
    branchCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    filteredCity: Observable<any[]>;
    filteredArea: Observable<any[]>;
    filteredState: Observable<any[]>;
    filteredDistrict: Observable<any[]>;
    @ViewChild('branchAutoComp') branchAutoComp;
    branchList$ = [];
    cityList$ = [];
    areaList = [];


    stateLists$ = [];
    districtLists$ = [];
    districtlist = [];
    itemList: any[] = [];
    allItemList: any[] = []; // Store all reference items
    // trigger-variable for Ladda
    isLoading: boolean = false;

    // Promo related variables
    promoTypeOptions: any[] = [];
    promoReferenceOptions: any[] = [];
    filteredPromoReferenceOptions: any[] = [];


    constructor(public store: Store<fromRootStore.State>, private phClientService: PhClientService, public snackBar: MdSnackBar, public bsModalRefs: BsModalRef, public bsModalRef: BsModalRef, public toasterService: ToasterService, private commonService: CommonService, private modalService: BsModalService, private promoTypeService: PromoTypeService, private promoReferenceService: PromoReferenceService) {
        //FOR AUTO COMPLETE VALIDATION --- REFERENCE COMBO
        function hasValidReference(input: FormControl) {
            let refID = input.value, retVal = null;
            if (refID == "") {
                retVal = { inValidReference: true };
            }
            if (refID && typeof refID === 'string') {
                retVal = { inValidReference: true };
            }
            return retVal;
        }
        this.clientCtrl = new FormControl('', [
            Validators.required,
            hasValidReference.bind(this)
        ]);

        function hasValidBranch(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                retVal = { inValidBranch: true };
            }
            return retVal;
        }
        this.branchControl = new FormControl('', [
            Validators.required,
            hasValidBranch.bind(this)
        ]);


        //this.clientCtrl = new FormControl();
        this.filteredItems = this.clientCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterItems(name) : this.itemList.slice());

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList$.slice());

        this.branchControl = new FormControl();
        this.filteredBranch = this.branchControl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList$.slice());

        this.cityCtrl = new FormControl();
        this.filteredCity = this.cityCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterCity(name) : this.cityList$.slice());

        this.areaCtrl = new FormControl();
        this.filteredArea = this.areaCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterArea(name) : this.areaList.slice());

        //  this.ClientSexCtrl = new FormControl();
        // this.MarStatusCtrl = new FormControl();

        // SEX 
        function hasValidSex(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Male" && ledgerID != "Female") {
                retVal = { inValidSex: true };
            }

            return retVal;
        }
        this.ClientSexCtrl = new FormControl('', [
            Validators.required,
            hasValidSex.bind(this)
        ]);

        // Marital 
        function hasValidMarital(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "Married" && ledgerID != "UnMarried") {
                retVal = { inValidMarital: true };
            }

            return retVal;
        }
        this.MarStatusCtrl = new FormControl('', [
            Validators.required,
            hasValidMarital.bind(this)
        ]);

        this.SalutationCtrl = new FormControl();
        this.salutationList = ['Dr', 'Madam', 'Master', 'Miss', 'Mr', 'Mrs', 'Ms'];

        // Assign To
        this.assignToCtrl = new FormControl();
        this.assignToList = [];

        this.clientSexList = ['Male', 'Female'];
        this.marStatusList = ['Married', 'UnMarried'];

        // Initialize Reference Client ID and Employee Name controls
        this.refClientCtrl = new FormControl({value: '', disabled: false});
        this.refEmployeeCtrl = new FormControl({value: '', disabled: false});

        // this.emailCtrl = new FormControl('', [
        //     //Validators.required,
        //     Validators.email,
        // ]);


    }

    ngOnInit(): void {
        let that = this;
        // Initialize promo field default value
        if (this.clientdata && !this.clientdata['promo']) {
            this.clientdata['promo'] = 'No';
        }
        //this.loadReferenceList();
        //this.loadAreaCity();
        //TO LOAD BRANCH MASTER
        this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                //this.store.dispatch(new commonActions.LoadAllBrand());
                //this.branchList$ = res.data;
                return;
            }
            this.branchList$ = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' && obj['is_hv_center'] == 'false' });

            // Get Assign To List
            that.getAssignToList(this.clientdata['branch']);
        });
        this.store.select(fromCommonStore.getAllReference).subscribe((res: any) => {
            if (_.isEmpty(res)) {
                //this.store.dispatch(new commonActions.LoadAllReference());
                //this.brandList$ = res;
                return;
            }
            this.allItemList = res; // Store all items
            this.filterReferenceList(); // Apply filtering
            that.clientCtrl.setValue(that.clientdata['ref_id']);
        });
        setTimeout(() => {
            $('#client_no').focus();
        }, 100);
        function hasValidState(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                let item = _.find(this.stateLists$, { 'StateName': branchID });
                if (item == undefined) {
                    retVal = { inValidState: true };
                }

            }
            return retVal;
        }
        this.stateCtrl = new FormControl('', [
            Validators.required,
            hasValidState.bind(this)
        ]);

        //this.stateCtrl = new FormControl();
        this.filteredState = this.stateCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterState(name) : this.stateLists$.slice());
        this.getStates();
        function hasValidDistrict(input: FormControl) {
            let branchID = input.value, retVal = null;
            if (branchID && typeof branchID === "string") {
                let item = _.find(this.districtLists$, { 'districts_name': branchID });
                if (item == undefined) {
                    retVal = { inValidDistrict: true };
                }
                //retVal = { inValidDistrict: true };
            }
            return retVal;
        }
        this.districtCtrl = new FormControl('', [
            Validators.required,
            hasValidDistrict.bind(this)
        ]);

        //this.districtCtrl = new FormControl();
        this.filteredDistrict = this.districtCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterDistrict(name) : this.districtlist.slice());
        this.getDistricts();

        // Reference Client ID - Dynamic search
        this.filteredRefClientList = this.refClientCtrl.valueChanges
            .startWith('')
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => {
                if (term && typeof term === 'string' && term.length >= 2) {
                    return Observable.fromPromise(this.searchRefClients(term));
                } else {
                    return Observable.of([]);
                }
            });

        // Reference Employee - Connect FormControl changes to search
        this.filteredRefEmployeeList = this.refEmployeeCtrl.valueChanges
            .startWith('')
            .debounceTime(300)
            .distinctUntilChanged()
            .switchMap(term => {
                if (term && typeof term === 'string' && term.length >= 2) {
                    return this.commonService.getEmployeeList(term, 'challan')
                        .do(data => console.log('Employee search results:', data));
                } else {
                    return Observable.of<any[]>([]);
                }
            })
            .catch(error => {
                console.log('Employee search error:', error);
                return Observable.of<any[]>([]);
            });

        // Load promo types and references
        this.loadPromoTypes();
        this.loadPromoReferences();
    }
    getStates() {
        let that = this;
        this.commonService
            .getStateList()
            .then(function (res: any) {
                if (res.success) {
                    that.stateLists$ = res.data;
                    that.displayStateFn(that.clientdata['state']);
                    that.stateCtrl.setValue(that.clientdata['state']);
                    that.districtCtrl.setValue(that.clientdata['districts']);
                }
            });
    }
    getDistricts() {
        let that = this;
        this.commonService
            .getDistrictList()
            .then(function (res: any) {
                if (res.success) {
                    that.districtLists$ = res.data;
                    that.displayStateFn(that.clientdata['state']);
                    that.stateCtrl.setValue(that.clientdata['state']);
                    that.districtCtrl.setValue(that.clientdata['old_district']);
                }
            });
    }

    // loadReferenceList() {
    //     let that = this;
    // //     this.commonService
    // //         .getReferenceList()
    // //         .then(function(res: any) {
    // //             that.itemList = res;
    // //             that.clientCtrl.setValue(that.clientdata['ref_id']);
    // // /*if (that.mode == "Edit") {
    // // 	that.brandCtrl.disable();
    // // 	$('#name').focus();
    // // }*/
    // //         });
    // }
    /*     loadAreaCity() {
            let that = this;
            this.commonService
                .getAreaCityList()
                .then(function(res: any) {
                    if (res.success) {
                        that.cityList$ = res.cityObj;
                        that.cityCtrl.setValue(that.clientdata['city']);
                        that.areaList = res.areaObj;
                        that.areaCtrl.setValue(that.clientdata['area']);
                    }
                });
        } */

    filterItems(name: string) {
        name = _.escapeRegExp(name);
        return this.itemList.filter(item => (new RegExp(name, 'gi').test(item.client_code) || new RegExp(name, 'gi').test(item.name)));
    }

    displayFn(item_id: number) {

        if (item_id && this.itemList.length > 0) {
            let fitem = _.find(this.itemList, { 'ref_id': item_id });
            return fitem['name'];
        }
        return '';
    }
    displayStateFn(stateid) {
        let that = this;

        /*let fitem =  _.filter(that.districtLists$, { 'state': stateid });

        that.districtlist = fitem;*/

        if (stateid != "" && stateid != undefined) {
            let fitem = _.filter(that.districtLists$, { 'state': stateid });
            that.districtlist = fitem;
            that.districtCtrl.setValue(this.clientdata['districts']);
        }


        return stateid;
    }
    onChangeState() {

        this.clientdata['districts'] = "";
    }

    displayDistrict(districtname) {
        let that = this;
        return districtname;
    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList$.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }

    displayBranchFn(branchID: number) {
        if (branchID && this.branchList$.length > 0) {
            let branchObj = _.find(this.branchList$, { 'branch_id': branchID });
            return branchObj['branch_name'];
        }
        return '';
    }
    filterCity(name: string) {
        name = _.escapeRegExp(name);
        return this.cityList$.filter(item => (new RegExp(name, 'gi').test(item.city)));
    }
    filterArea(name: string) {
        name = _.escapeRegExp(name);
        return this.areaList.filter(item => (new RegExp(name, 'gi').test(item.area)));
    }
    filterState(name: string) {
        name = _.escapeRegExp(name);
        return this.stateLists$.filter(item => (new RegExp(name, 'gi').test(item.StateName)));
    }
    filterDistrict(name: string) {
        name = _.escapeRegExp(name);
        return this.districtlist.filter(item => (new RegExp(name, 'gi').test(item.districts_name)));
    }

    /*onSelectedBrand(mdCompEvent: any) {
        let item_id = mdCompEvent.option.value,
            fitem = _.find(this.itemList, { 'brand_id': item_id });
        //this.skudata['jms_item_id'] = fitem.item_id;
        this.brandmodeldata['brandmodel_id'] = fitem.brand_code;
        this.brandmodeldata['brandmodel_name'] = fitem.name;
    }*/

    calculateAge(): void {
        let dob = new Date(moment(this.clientdata['dob']).format('YYYY-MM-DD')),
            today = new Date(moment(new Date()).format('YYYY-MM-DD')),
            age = 0;

        let timeDiff = Math.abs(today.getTime() - dob.getTime());
        age = Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);//Math.ceil(timeDiff / (1000 * 3600 * 24));
        this.clientdata['age'] = age;
    }

    onEnterKeyPressed(nextEl: string): void {
        if (nextEl == 'age') {
            this.calculateAge();
        }
        $('#' + nextEl).focus();
    }
    onPhotoUploadFinished(res) {
        let serRes = JSON.parse(res.serverResponse._body);
        if (serRes.success) {
            this.clientdata['client_photo'] = serRes['filename'];
        }
    }
    onPhotoRemoved(res) {
        let that = this;
        if (this.clientdata['mode'] == "Edit") {
            this.phClientService
                .deletePhoto(this.clientdata)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        this.toasterService.pop({
                            bodyOutputType: 1,
                            type: 'success',
                            title: 'SUCCESS',
                            body: 'Photo removed successfully'
                        });
                    } else {
                        swal('ERROR', res.message, 'error');
                    }

                })
                .catch(function (error: any) {
                    that.isLoading = false;
                    let res = JSON.parse(error._body);
                    swal('ERROR', res.message, 'error');
                });
        }
    }
    onAddReference(): void {
        let that = this,
            row = {
                "mode": "Add"
            };
        // setTimeout(function() {
        //     that.filterPanel.close();
        // }, 10);
        this.bsModalRefs = this.modalService.show(AddEditReferenceComponent, {
            keyboard: false,
            ignoreBackdropClick: true,
            class: 'client-reference-window'
        });
        //row['mode'] = mode;
        this.bsModalRefs.content.title = 'Add Reference Details';
        //this.bsModalRefs.content.from_page = 'Client';
        this.bsModalRefs.content.referencedata = Object.assign({}, row);
        this.bsModalRefs.content.referenceLoadEvent.subscribe(($e) => {
            //that.loadReferenceList();
            that.store.dispatch(new commonActions.LoadAllReference());
        });
    }

    getAssignToList(branch_name) {
        let that = this;
        let data = {
            user_branch_name: branch_name
        }
        this.commonService.getUserList(data).then(function (res: any) {
            that.assignToList = res.data;
        });
    }

    assignFn(val) {
        return val ? this.assignToList.find(x => x.userid == val).fullname : val;
    }

    onSaveClient(): void {
        let dob = '0000-00-00',
            toast = {
                type: 'warning',
                title: 'WARNING'
            };
        /*    if (_.isEmpty(_.toString(this.clientdata['ref_id']))) {
                toast['body'] = 'Please Select Reference';
                this.toasterService.pop(toast);
                return;
            }
            if (_.isDate(this.clientdata['dob'])) {
                dob = moment(this.clientdata['dob']).format('YYYY-MM-DD');
            }*/

        if (_.isEmpty(_.toString(this.clientdata['area']))) {
            toast['body'] = 'Please Enter Area';
            this.toasterService.pop(toast);
            return;
        }
        if (_.isEmpty(_.toString(this.clientdata['pin_code']))) {
            toast['body'] = 'Please Enter Pin Code';
            this.toasterService.pop(toast);
            return;
        }
        if (!this.clientdata['alt_mobile']) {
            swal({ title: 'Warning', text: 'Please Enter Alternative Number', type: 'warning' });
            return;
        }
        if (this.clientdata['mobile'] && this.clientdata['alt_mobile'] && (this.clientdata['mobile'] == this.clientdata['alt_mobile'])) {
            toast['body'] = 'Warning: Alternative Number is same as Mobile Number';
            this.toasterService.pop(toast);
        }
        let that = this,
            data = {
                mode: this.clientdata['mode'],
                client_id: this.clientdata['client_id'],
                client_no: this.clientdata['client_no'],
                client_name: this.clientdata['client_name'],
                salutation: this.clientdata['salutation'],
                dob: dob,
                age: this.clientdata['age'],
                sex: this.clientdata['sex'],
                marital_status: this.clientdata['marital_status'],
                address: this.clientdata['address'],
                area: this.clientdata['area'],
                city: this.clientdata['city'],
                state: this.clientdata['state'],
                pin_code: this.clientdata['pin_code'],
                mobile: this.clientdata['mobile'],
                alt_mobile: this.clientdata['alt_mobile'],
                landline: this.clientdata['landline'],
                aadhar_no: this.clientdata['aadhar_no'],
                profession: this.clientdata['profession'],
                email_id: this.clientdata['email_id'],
                ref_id: this.clientdata['ref_id'],
                reference_by: this.clientdata['reference_by'],
                reg_branch: this.clientdata['branch'],
                client_photo: this.clientdata['client_photo'],
                district: this.clientdata['districts'],
                reference1: this.clientdata['reference1'],
                assign_emp_id: this.clientdata['assign_emp_id'],
                ref_client_id: this.extractClientId(this.clientdata['ref_client_id']),
                ref_employee_id: this.extractEmployeeId(this.clientdata['ref_employee_id']),
                promo: this.clientdata['promo'],
                promo_type_id: this.clientdata['promo_type_id'],
                promo_reference_id: this.clientdata['promo_reference_id']
            };
        data['tabEvent'] = undefined;
        this.isLoading = true;
        this.phClientService
            .addUpdateClient(data)
            .then(function (res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.clientUpdateEvent.emit(data);
                } else {

                    swal('Warning', res.message, 'error');
                    if (res.overwrite == 'Yes') {
                        swal({
                            title: 'Already Exist',
                            text: res.message + ' You Want to Save Again',
                            showCancelButton: true,
                            confirmButtonText: 'Yes, Continue!',
                            cancelButtonText: 'No, Cancel'
                        }).then(function () {

                            let datas = {
                                mode: that.clientdata['mode'],
                                client_id: that.clientdata['client_id'],
                                client_no: that.clientdata['client_no'],
                                client_name: that.clientdata['client_name'],
                                dob: dob,
                                overwrite: 'yes',
                                salutation: that.clientdata['salutation'],
                                assign_emp_id: that.clientdata['assign_emp_id'],
                                age: that.clientdata['age'],
                                sex: that.clientdata['sex'],
                                marital_status: that.clientdata['marital_status'],
                                address: that.clientdata['address'],
                                area: that.clientdata['area'],
                                city: that.clientdata['city'],
                                state: that.clientdata['state'],
                                pin_code: that.clientdata['pin_code'],
                                mobile: that.clientdata['mobile'],
                                alt_mobile: that.clientdata['alt_mobile'],
                                landline: that.clientdata['landline'],
                                aadhar_no: that.clientdata['aadhar_no'],
                                profession: that.clientdata['profession'],
                                email_id: that.clientdata['email_id'],
                                ref_id: that.clientdata['ref_id'],
                                reference_by: that.clientdata['reference_by'],
                                reg_branch: that.clientdata['branch'],
                                client_photo: that.clientdata['client_photo'],
                                district: that.clientdata['districts'],
                                reference1: that.clientdata['reference1'],
                                ref_client_id: that.extractClientId(that.clientdata['ref_client_id']),
                                ref_employee_id: that.extractEmployeeId(that.clientdata['ref_employee_id']),
                                promo: that.clientdata['promo'],
                                promo_type_id: that.clientdata['promo_type_id'],
                                promo_reference_id: that.clientdata['promo_reference_id']
                            };
                            datas['tabevent'] = undefined;
                            that.isLoading = true;
                            that.phClientService
                                .addUpdateClient(datas)
                                .then(function (res: any) {
                                    that.isLoading = false;
                                    if (res.success) {
                                        swal('SUCCESS', res.message, 'success');
                                        that.bsModalRef.hide();
                                        that.clientUpdateEvent.emit(data);
                                    } else {

                                        swal('Warning', res.message, 'error');
                                    }
                                });
                        }, function (dismiss) {

                        });
                    }
                    // that.bsModalRef.hide();
                    //  that.clientUpdateEvent.emit(data);
                    /*  var toast = {
                          type: 'error',
                          title: 'ERROR',
                          body: res.message
                      };*/

                    //  that.toasterService.pop(toast);
                    //swal('SUCCESS', res.message, 'success');
                }

            })
            .catch(function (error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }
    showRef() {
        if (this.clientdata['ref_id'] == 9) {
            this.showReference = true;
            // Enable the reference fields when showReference is true
            this.refClientCtrl.enable();
            this.refEmployeeCtrl.enable();
        } else {
            this.showReference = false;
            // Disable the reference fields when showReference is false
            this.refClientCtrl.disable();
            this.refEmployeeCtrl.disable();
        }
    }

    // Reference Client search function
    searchRefClients(query: string): Promise<any[]> {
        let data = {
            search: query
        };
        return this.phClientService.searchRefClients(data)
            .then(function(res: any) {
                if (res.success) {
                    return res.data;
                } else {
                    return [];
                }
            })
            .catch(function(error: any) {
                return [];
            });
    }



    // Display functions for autocomplete
    displayRefClientFn(client: any) {
        if (client && typeof client === 'object') {
            return client.client_no + ' - ' + client.client_name;
        }
        return client;
    }

    displayRefEmployeeFn(employee: any) {
        if (employee && typeof employee === 'object') {
            return employee.empname || employee.fullname;
        }
        return employee;
    }

    // Helper methods to extract IDs from objects
    extractClientId(client: any): string {
        if (client && typeof client === 'object' && client.client_id) {
            return client.client_id;
        }
        return '';
    }

    extractEmployeeId(employee: any): string {
        if (employee && typeof employee === 'object') {
            return employee.empid || employee.userid || '';
        }
        return '';
    }

    // Promo-related methods
    loadPromoTypes(): void {
        this.promoTypeService
            .getActivePromoTypes()
            .then((res: any) => {
                if (res && res.data) {
                    this.promoTypeOptions = res.data;
                }
            })
            .catch((error) => {
                console.error('Error loading promo types:', error);
            });
    }

    loadPromoReferences(): void {
        this.promoReferenceService
            .getActivePromoReferences()
            .then((res: any) => {
                if (res && res.data) {
                    this.promoReferenceOptions = res.data;
                }
            })
            .catch((error) => {
                console.error('Error loading promo references:', error);
            });
    }

    onPromoChange(): void {
        if (this.clientdata['promo'] === 'No') {
            // Clear promo-related fields when promo is set to No
            this.clientdata['promo_type_id'] = '';
            this.clientdata['promo_type_display'] = '';
            this.clientdata['promo_reference_id'] = '';
            this.clientdata['promo_reference_display'] = '';
            this.clientdata['promo_reference_details'] = '';
            this.filteredPromoReferenceOptions = [];
        } else {
            // Ensure data is loaded when promo is set to Yes
            if (this.promoTypeOptions.length === 0) {
                this.loadPromoTypes();
            }
            if (this.promoReferenceOptions.length === 0) {
                this.loadPromoReferences();
            }
        }
    }

    onPromoTypeSelection(promoType: any): void {
        this.clientdata['promo_type_id'] = promoType.promo_type_id;
        this.clientdata['promo_type_display'] = promoType.promo_type;

        // Clear promo reference fields when promo type changes
        this.clientdata['promo_reference_id'] = '';
        this.clientdata['promo_reference_display'] = '';
        this.clientdata['promo_reference_details'] = '';

        // Filter promo references based on selected promo type
        this.filteredPromoReferenceOptions = this.promoReferenceOptions.filter(
            ref => ref.promo_type_id == promoType.promo_type_id
        );
    }

    onPromoTypeInputChange(event: any): void {
        const typedValue = event.target.value;

        // Find matching promo type by name
        const matchingPromoType = this.promoTypeOptions.find(
            promoType => promoType.promo_type === typedValue
        );

        if (matchingPromoType) {
            this.onPromoTypeSelection(matchingPromoType);
        } else {
            // Clear references if no match found
            this.clientdata['promo_type_id'] = '';
            this.clientdata['promo_reference_id'] = '';
            this.clientdata['promo_reference_display'] = '';
            this.clientdata['promo_reference_details'] = '';
            this.filteredPromoReferenceOptions = [];
        }
    }

    onPromoReferenceSelection(promoReference: any): void {
        this.clientdata['promo_reference_id'] = promoReference.promo_reference_id;
        this.clientdata['promo_reference_display'] = promoReference.promo_reference;
        this.clientdata['promo_reference_details'] = promoReference.promo_reference_details || '';
    }

    filterReferenceList(): void {
        // Always filter out OC-DR and OC-ADVT for add mode
        // Check both mode property and clientdata mode, defaulting to Add if neither is set
        const currentMode = this.mode || this.clientdata['mode'] || 'Add';
        if (currentMode === 'Add') {
            this.itemList = _.filter(this.allItemList, function (obj) {
                return obj['name'] !== 'OC-DR' && obj['name'] !== 'OC-ADVT';
            });
        } else {
            this.itemList = this.allItemList;
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/phClient/addEditphClient.component.ts